export default function toUnit(value, unit = "px") {
    return typeof value === "number" ? `${value}${unit}` : value;
}
//# sourceMappingURL=toUnit.js.map